module.exports = __webpack_public_path__ + "img/pumping-activities-role6.d01a0e26.png";